module.exports = __webpack_public_path__ + "static/media/react.520b26e6.svg";